import { faCommentDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import styled from "styled-components";
import { ATTENDANCE_STATUS_OPTIONS } from "constants/status";
import { hasPermission } from "utility/helpers";
import { CellText, StyledTrashIcon } from "assets/js/Styles";
import CustomSelect from "components/customs/dropdown";
import { statusSelectStyles } from "constants/style";

const allowedBumpStatus = ["Invited", "No Response"];

const StyledDropdown = styled(CustomSelect)`
  width: 100%;

  .select__control:has(.did-not-attend-status) {
    background-color: #e1700d;
    border: none;
    .did-not-attend-status {
      color: white;
    }
  }

  .select__control:has(.invited-status) {
    background-color: #00316d;
    border: none;
    .invited-status {
      color: white;
    }
  }

  .select__control:has(.confirmed-status) {
    background-color: #53a24c;
    border: none;
    .confirmed-status {
      color: white;
    }
  }

  .select__control:has(.declined-status) {
    background-color: #df3348;
    border: none;
    .declined-status {
      color: white;
    }
  }

  .select__control:has(.no-response-status) {
    background-color: #ffbd14;
    border: none;
    .no-response-status {
      color: white;
    }
  }

  .select__control:has(.attended-status) {
    background-color: #265ea3;
    border: none;
    .attended-status {
      color: white;
    }
  }
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.iconBlue};
  margin-left: 8px;
  cursor: pointer;
`;

const eventAttendanceLogColumns = ({
  handleStatusChange,
  handleAttendanceModal,
  handleDeleteAction,
  handleBumpIconOnClicked,
  timer,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "Member Name",
      selector: (Congressman) => Congressman?.fullName,
      identifier: "Congressman.fullName",
      grow: 2,
      sortable: true,
      cell: ({ Congressman }) => <CellText>{Congressman?.fullName}</CellText>,
    },
    {
      name: "Status",
      selector: (eventParticipantStatus) => eventParticipantStatus,
      identifier: "eventParticipantStatus",
      grow: 1,
      sortable: true,
      cell: ({ eventParticipantStatus }, index) => {
        return (
          <StyledDropdown
            isSearchable={false}
            getOptionLabel={(option) => {
              return option?.displayLabel;
            }}
            menuPortalTarget={document.body}
            styles={statusSelectStyles}
            options={ATTENDANCE_STATUS_OPTIONS}
            onChange={(option) => {
              handleStatusChange(index, option);
            }}
            value={ATTENDANCE_STATUS_OPTIONS.find(
              (stat) => stat?.value === eventParticipantStatus
            )}
          />
        );
      },
    },
    {
      name: "Days Attended",
      selector: (record) => record,
      identifier: "attendanceCount",
      sortable: true,
      cell: (record) => (
        <a
          href="!#"
          onClick={(e) => {
            e.preventDefault();
            handleAttendanceModal(record.id);
          }}
        >
          {record.attendanceCount}
        </a>
      ),
    },
    {
      name: "Is Invited?",
      selector: (record) => record.isInvited,
      identifier: "isInvited",
      grow: 1,
      sortable: true,
      id: "isInvited",
      cell: (record) => {
        return <CellText>{record.isInvited ? "Yes" : "No"}</CellText>;
      },
    },
    {
      name: "Attended by Proxy?",
      selector: (record) => record.attendedByProxy,
      identifier: "attendedByProxy",
      grow: 1,
      sortable: true,
      cell: (record) => {
        return <CellText>{record.attendedByProxy ? "Yes" : ""}</CellText>;
      },
    },
    {
      name: "Actions",
      selector: (rowData) => rowData?.id,
      sortable: false,
      grow: 1,
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (rowData) => {
        const isBumpIconDisabled =
          timer &&
          timer?.find((time) => time?.id === rowData.id && time?.isActive);

        if (!hasPermission("event-delete")) return null;

        return (
          <>
            <StyledTrashIcon
              size={16}
              id={`delete-row--${rowData.id}`}
              onClick={() => handleDeleteAction(rowData)}
            />
            <UncontrolledTooltip
              placement="left"
              target={`delete-row--${rowData.id}`}
            >
              {"Delete"}
            </UncontrolledTooltip>

            {allowedBumpStatus.includes(rowData.eventParticipantStatus) && (
              <>
                <StyledFontAwesomeIcon
                  id={`bump-row--${rowData.id}`}
                  icon={faCommentDollar}
                  size="xl"
                  style={
                    !isBumpIconDisabled
                      ? { cursor: "pointer" }
                      : { cursor: "initial", pointerEvents: "none" }
                  }
                  disabled={isBumpIconDisabled}
                  onClick={() =>
                    handleBumpIconOnClicked(
                      rowData.id,
                      rowData.Congressman?.fullName
                    )
                  }
                />
                <UncontrolledTooltip
                  placement="top"
                  target={`bump-row--${rowData.id}`}
                >
                  {"Bump"}
                </UncontrolledTooltip>
              </>
            )}
          </>
        );
      },
    },
  ];
};

export default eventAttendanceLogColumns;
